import request from '../utils/request';
import type { 
  WarehouseListParams, 
  WarehouseListResponse, 
  WarehouseDetail,
  WarehouseUpdatePayload,
} from '../types/warehouse';

export function getWarehouseList(params: WarehouseListParams) {
  return request.get<WarehouseListResponse>('/api/v1/warehouses/', { params });
}

export function getWarehouseDetail(id: number) {
  return request.get<WarehouseDetail>(`/api/v1/warehouses/${id}/`);
}

export function updateWarehouse(id: number, data: WarehouseUpdatePayload) {
  return request.patch<WarehouseDetail>(`/api/v1/warehouses/${id}/`, data);
}